import React from 'react';

const CustomBarChart: React.FC<{
  labels: string[];
  nominatedData: number[];
  deliveredData: number[];
  expectedData: number[];
  setSelectedMarket: (market: string) => void;
  setShowModal: (show: boolean) => void;
  currentMonth: string;
}> = ({ labels, nominatedData, deliveredData, expectedData, setSelectedMarket, setShowModal}) => {
  const containerWidth = '60%';
  const barHeight = 30;

  return (
    <div style={{
      padding: '30px',
      backgroundColor: '#ffffff',
      // backgroundColor: 'red',
      color: '#000000',
      display: 'flex',
      flexDirection: 'column',
    }}>
      {/* Legend with light gray box */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        gap: '30px',
        marginBottom: '30px',
        fontSize: '16px',
        fontWeight: 'bold',
        padding: '15px',
        backgroundColor: '#f5f5f5',
        borderRadius: '6px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div style={{
            width: '20px',
            height: '20px',
            backgroundColor: '#03A9F4',
            borderRadius: '3px'
          }} />
          <span>Delivered Volume</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div style={{
            width: '20px',
            height: '20px',
            backgroundColor: '#4CAF50',
            borderRadius: '3px'
          }} />
          <span>Expected Volume</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div style={{
            width: '20px',
            height: '20px',
            backgroundColor: '#666666',
            borderRadius: '3px'
          }} />
          <span>Nominated Volume</span>
        </div>
      </div>

      {/* Graph container - now with white background (no surrounding gray box) */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '40px',
        width: '100%',
        // backgroundColor: 'green',
      }}>
        {labels.map((label, index) => {
          const rawNominated = nominatedData[index] || 0;
          const expectedVol = expectedData[index] || 0;
          const deliveredVol = deliveredData[index] || 0;
          const noNomination = rawNominated < 1;
          const nominatedVol = rawNominated;

          // When there's no real nomination, scale bars against the larger of
          // delivered/expected so we can still see their relative size.
          const referenceVol = noNomination
            ? Math.max(expectedVol, deliveredVol, 1)
            : nominatedVol;

          const expectedWidth = Math.min((expectedVol / referenceVol) * 100, 100);
          const deliveredWidth = Math.min((deliveredVol / referenceVol) * 100, 100);

          return (
            <div
              key={label}
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '15px',
                cursor: 'pointer',
                position: 'relative',
                // backgroundColor: 'blue',
              }}
              onClick={() => {
                setSelectedMarket(label);
                setShowModal(true);
              }}
            >
              {/* Market/station name */}
              <div style={{
                width: '200px',
                fontSize: '14px',
                fontWeight: '500',
                textAlign: 'right',
                color: '#000000'
              }}>
                {label}
              </div>

              {/* Main bar container */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                width: containerWidth,
                position: 'relative'
              }}>
                {/* Progress bar background */}
                <div style={{
                  width: '100%',
                  height: `${barHeight}px`,
                  backgroundColor: '#e0e0e0', // Light gray for bar background
                  borderRadius: '4px',
                  overflow: 'hidden',
                  position: 'relative'
                }}>
                  {/* Expected Volume (green) */}
                  {(
                    <div
                      style={{
                        position: 'absolute',
                        width: `${expectedWidth}%`,
                        height: '100%',
                        backgroundColor: '#4CAF50'
                      }}
                    />
                  )}

                  {/* Delivered Volume (blue) */}
                  <div
                    style={{
                      position: 'absolute',
                      width: `${deliveredWidth}%`,
                      height: '100%',
                      backgroundColor: '#03A9F4'
                    }}
                  />
                </div>

                {/* Nominated Volume value */}
                <div style={{
                  marginLeft: '15px',
                  fontSize: '14px',
                  fontWeight: noNomination ? 'normal' : 'bold',
                  minWidth: '110px',
                  color: noNomination ? '#999999' : '#000000',
                  fontStyle: noNomination ? 'italic' : 'normal'
                }}>
                  {noNomination ? 'No Nomination' : nominatedVol.toLocaleString()}
                </div>
              </div>

              {/* Floating values */}
              <div style={{
                position: 'absolute',
                left: '215px',
                top: '100%',
                width: containerWidth,
                marginTop: '5px',
                display: 'flex',
                // justifyContent: 'space-between'
                // color: 'red',
              }}>
                {/* Expected Volume value */}
                {expectedVol > 0 && (

                  <div style={{
                    position: 'absolute',
                    right: 0,
                    color: '#4CAF50',
                    fontSize: '12px',
                    minWidth: '60px',
                    textAlign: 'center'
                  }}>
                    {expectedVol.toLocaleString()}
                  </div>
                )}

                {/* Delivered Volume value */}
                <div style={{
                  position: 'absolute',
                  right: 140,
                  color: '#03A9F4',
                  fontSize: '12px',
                  minWidth: '60px',
                  textAlign: 'center'
                }}>
                  {deliveredVol.toLocaleString()}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export { CustomBarChart };